import { render, staticRenderFns } from "./District.vue?vue&type=template&id=c13a1244&scoped=true&"
import script from "./District.vue?vue&type=script&lang=ts&"
export * from "./District.vue?vue&type=script&lang=ts&"
import style0 from "./District.vue?vue&type=style&index=0&id=c13a1244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13a1244",
  null
  
)

export default component.exports